import { fontWeight } from "@mui/system";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";

import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";

import calendar from "../../assets/calendar.svg";
import { LabelDiv } from "../../components/PaymentPlanTabs/Tabs.styled";

import NocsRequests from "../../stores/NocsRequestsStore";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import { Box } from "@mui/material";
import "./style.css";
// import { Label } from "src/screens/complaint/Complaint.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { InfoContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { SpinnerRaw } from "../spinner.component";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import Modal from "@mui/material/Modal";
import TrackStatusModal from "./TrackStatusModal";
interface Obj {
  [key: string]: string | {} | [];
}

interface Props extends BaseProps {
  onClose: () => void;
}

const TrackRequests = ({ onClose }: Props) => {
  const fromDateRef = useRef<HTMLInputElement>(null);
  const toDateRef = useRef<HTMLInputElement>(null);
  const [loader, setLoader] = useState(false);
  const [filter, setFilter] = useState<string | null>(null);
  const trackRequestInputRef = useRef<HTMLInputElement | null>(null);
  const [referenceNumber, setReference] = useState<any>();
  
  const [trackDetails, setTrackDetails] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const getTrackRequests = async () => {
    setLoader(true);
    const trackId = trackRequestInputRef?.current?.value;
    const data = {
      trackId,
    };

    const response = await NocsRequests.getTrackRequestStatus({
      errorId: "getTrackRequestsError",
      data,
    });
    setIsModalOpen(true);
    setLoader(false)
    setTrackDetails(response?.result);
  };

  
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {}, []);
  const contrast = General?.contrast;
  const ColorAss = General?.ColorAss;
  return (
    <Box
      sx={{
        margin: " 6rem 20rem",
        "@media (max-width: 768px)": {
          margin: 0, // Remove the margin below 768px
        },
      }}
    >
      <div
        style={{
          backgroundColor: "#101e8e",
          padding: 15,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1
          id="modal-title"
          style={{
            color: "white",
            margin: 0,
            fontSize: `${2 * General.accessibility.fontSize}rem`,
          }}
        >
          {General?.codeLabels["cm_track_req"]?.label
            ? General?.codeLabels["cm_track_req"]?.label
            : "Track Requests"}
        </h1>
        <span
          style={{
            color: "white",
            fontSize: `${2 * General.accessibility.fontSize}rem`,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          x
        </span>
      </div>

      <Box
        sx={{
          backgroundColor: "#fff",
          padding: { xs: "30px 9px", md: "30px" },
          color: "#101E8E",
          height: {
            xs: "30vh", // Set height to 100vh below 768px
            sm: "20vh", // Set height to 80vh for screens 768px and above
          },
        }}
      >
        <InfoContainer>
          <Label
            className={General?.textClass}
            style={{
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "16px",
              gap: "0.5rem",
              height: "100px",
              position: "relative",
              width: General?.isLargeScreen ? "100%" : "100%",
            }}
          >
            {General?.codeLabels["cm_track_reference"]?.label !== undefined
              ? General?.codeLabels["cm_track_reference"]?.label
              : "Form Reference Number"}
            <input
              type="number"
              ref={trackRequestInputRef}
              value={referenceNumber}
              style={{ width: "100%" }}
              onChange={(e) => setReference(e.target.value)}
            />
          </Label>
          <Label
            className={General?.textClass}
            style={{
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: `${General.accessibility.fontSize}rem`,
              lineHeight: "16px",
              gap: "0.5rem",
              height: "100px",
              position: "relative",
              width: General?.isLargeScreen ? "" : "100%",
              marginTop: "1rem",
            }}
          >
            <ButtonSecondary
              style={{
                width: General?.isLargeScreen ? "50%" : "98%",
                height: "55px",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "white",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "#101e8e",
                  whiteSpace:"nowrap"
              }}
              onClick={getTrackRequests}
              // onClick={()=>navigate(-1)}
            >
              {loader?<SpinnerRaw width={30} height={30}/>: General?.codeLabels["cm_getStatus"]?.label !== undefined
                ? General?.codeLabels["cm_getStatus"]?.label
                : "Get Status"}
            </ButtonSecondary>
          </Label>
        </InfoContainer>
      </Box>
      <Modal open={isModalOpen} onClose={handleCancel}>
        <TrackStatusModal
          onValidateClick={handleCancel}
          trackDetails={trackDetails}
        />
      </Modal>
    </Box>
  );
};

export default observer(TrackRequests);
